/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Payout_ReleasedInputs */

const en_rental_payout_released = /** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout Released`)
};

const es_rental_payout_released = /** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago Liberado`)
};

const fr_rental_payout_released = /** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement débloqué`)
};

const de_rental_payout_released = /** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung freigegeben`)
};

const id_rental_payout_released = /** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran Dilepaskan`)
};

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const ja_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const zh_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const ar_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const it_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const ru_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const pt_rental_payout_released = en_rental_payout_released;

/** @type {(inputs: Rental_Payout_ReleasedInputs) => LocalizedString} */
const ko_rental_payout_released = en_rental_payout_released;

/**
* | output |
* | --- |
* | "Payout Released" |
*
* @param {Rental_Payout_ReleasedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_payout_released = /** @type {((inputs?: Rental_Payout_ReleasedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Payout_ReleasedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_payout_released(inputs)
	if (locale === "es") return es_rental_payout_released(inputs)
	if (locale === "fr") return fr_rental_payout_released(inputs)
	if (locale === "de") return de_rental_payout_released(inputs)
	if (locale === "ja") return ja_rental_payout_released(inputs)
	if (locale === "zh") return zh_rental_payout_released(inputs)
	if (locale === "ar") return ar_rental_payout_released(inputs)
	if (locale === "id") return id_rental_payout_released(inputs)
	if (locale === "it") return it_rental_payout_released(inputs)
	if (locale === "ru") return ru_rental_payout_released(inputs)
	if (locale === "pt") return pt_rental_payout_released(inputs)
	return ko_rental_payout_released(inputs)
});